import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { styled } from "@mui/material/styles";
import { TransitionProps } from "@mui/material/transitions";
import React, { ReactElement, Ref, forwardRef } from "react";

import { AlertDialogProps } from "./AlertDialog";

const StyledHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AlertDialog: React.FC<AlertDialogProps> = ({
  openDialog,
  children,
  onAccept,
  dialogTitle,
  setOpenDialog,
  isLoading,
  submitButtonType = "button",
}) => {
  const handleClose = () => setOpenDialog(false);
  const handleOnAccept = () => {
    onAccept();
    setOpenDialog(false);
  }

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      TransitionComponent={Transition}
      keepMounted
      fullWidth
    >
      <StyledHeader>
        <DialogTitle>
          {dialogTitle}
        </DialogTitle>
      </StyledHeader>
      <Box>
        <DialogContent>
          <DialogContentText>
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            size="large"
          >
            Close
          </Button>
          <LoadingButton
            onClick={handleOnAccept}
            color="primary"
            variant="contained"
            size="large"
            type={submitButtonType}
            disabled={isLoading}
            loading={isLoading}
          >
            Proceed
          </LoadingButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
}